import _ from 'underscore';
import 'jquery';
import kendo from '@bingads-webui/kendo/kendo.core';

import {
  RECOMMENDATION_TYPES,
  ESTIMATE_TYPES,
  SEASONAL_TRACKID,
  MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS,
  BUDGET_OPPORTUNITY_TYPES,
  SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES,
  RECOMMENDATION_CATEGORIES,
  TOP_POSITION_RECOMMENDATION_TYPES,
} from './consts';

import { getFieldValueFromGridData } from './util';

// #region estimates
export const getEstimates = (type, entity) => {
  const estimates = {
    costIncrease: entity.EstimatedIncreaseInCost,
    clicksIncrease: entity.EstimatedIncreaseInClicks,
  };

  switch (type) {
    case RECOMMENDATION_TYPES.BUDGET:
    case RECOMMENDATION_TYPES.COMPETITIVE_BID:
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST:
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST:
      estimates.imprShareCurrent = entity.CurSelfImprShare;
      estimates.imprShareIncrease = entity.EstimatedIncreaseInImprShare;
      estimates.imprShareTotal = entity.CurSelfImprShare + entity.EstimatedIncreaseInImprShare;
      if (entity.EstimatedIncreaseInConversionsInt > 0) {
        estimates.convIncrease = entity.EstimatedIncreaseInConversionsInt;
      }
      break;
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT:
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED:
    case RECOMMENDATION_TYPES.FACEBOOK_IMPORT:
      estimates.clicksCurrent = entity.CurrentClicks;
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      break;
    case RECOMMENDATION_TYPES.SITE_LINK:
    case RECOMMENDATION_TYPES.CALLOUT:
      estimates.ctrCurrent = entity.CurrentCtr;
      estimates.ctrIncrease = entity.EstimatedIncreaseInCtr;
      estimates.ctrLift = entity.CtrLift;
      estimates.cpcIncrease = entity.EstimatedIncreaseInCpc;
      break;
    case RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY:
    case RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY:
      if (entity.EstimatedIncreaseInConversionsInt > 0) {
        estimates.primaryEstimate = ESTIMATE_TYPES.CONVERSIONS;
        estimates.convCurrent = entity.CurrentConversionsInt;
        estimates.convIncrease = entity.EstimatedIncreaseInConversionsInt;
      } else {
        estimates.primaryEstimate = ESTIMATE_TYPES.CLICKS;
        estimates.clicksCurrent = entity.CurrentClicks;
      }
      break;
    case RECOMMENDATION_TYPES.NEW_KEYWORD: // deprecated in Oct 2023
    case RECOMMENDATION_TYPES.NEW_LOCATION:
    case RECOMMENDATION_TYPES.SYNDICATION:
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      estimates.impressionsCurrent = entity.CurrentImpressions;
      if (entity.EstimatedIncreaseInConversionsInt > 0) {
        estimates.convIncrease = entity.EstimatedIncreaseInConversionsInt;
      }
      break;
    case RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS:
      estimates.weeklySearchesIncrease = entity.EstimatedIncreaseInSearches;
      break;
    case RECOMMENDATION_TYPES.IMAGE_EXTENSION:
    case RECOMMENDATION_TYPES.REALLOCATE_BUDGET:
      estimates.clicksCurrent = entity.CurrentClicks;
      estimates.costCurrent = entity.CurrentCost;
      break;
    case RECOMMENDATION_TYPES.FIX_AD_TEXT:
    case RECOMMENDATION_TYPES.FIX_AD_DESTINATION:
      estimates.primaryEstimate = ESTIMATE_TYPES.REJECTED_ADS;
      estimates.secondPrimaryEstimate = ESTIMATE_TYPES.REJECTED_KEYWORDS;
      estimates.isDoublePrimary = true;
      estimates[`${ESTIMATE_TYPES.REJECTED_ADS}Increase`] = entity.NumberRejectedAds;
      estimates[`${ESTIMATE_TYPES.REJECTED_KEYWORDS}Increase`] = entity.NumberRejectedKeywords;
      break;
    case RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL:
    case RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS:
      estimates.missingConvIncrease = entity.EstimatedIncreaseInConversionsInt;
      break;
    case RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS:
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      estimates.impressionsCurrent = entity.CurrentImpressions;
      break;
    case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS:
      estimates.clicksCurrent = entity.CurrentClicks;
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      break;
    case RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER:
      estimates.impressionsCurrent = entity.CurrentImpressions;
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      estimates.targetedProductsIncrease = entity.SumofTotalUntargetedOfferCnt;
      break;
    case RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS:
      estimates.clicksIncrease = entity.EstimatedIncreaseInClicks;
      estimates.impressionsIncrease = entity.EstimatedIncreaseInImpressions;
      break;
    case RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION:
      estimates.convIncrease = entity.EstimatedIncreaseInConversionsInt;
      break;
    case RECOMMENDATION_TYPES.SYNDICATION_GAP:
      estimates.clicksIncrease = entity.EstimatedIncreaseInClicks;
      estimates.convIncrease = entity.EstimatedIncreaseInConversionsInt;
      break;
    // No estimates
    case RECOMMENDATION_TYPES.REPAIR_ADS:
    case RECOMMENDATION_TYPES.REPAIR_KEYWORD:
    case RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD:
    case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS:
    case RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY:
    case RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY:
    case RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY:
    case RECOMMENDATION_TYPES.TRENDING_QUERY:
    case RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD:
    case RECOMMENDATION_TYPES.MULTIMEDIA_ADS:
    case RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID:
    case RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION:
    case RECOMMENDATION_TYPES.PMAX_IMPORT:
      return null;
    default:
      throw new Error(`Not Implemented: ${type}`);
  }

  return estimates;
};
// #endregion estimates

// #region chart/map/table
const formatDate = (day, hour) => kendo.toString(kendo.parseDate(`${day}${hour || 0}`, 'yyyyMMddH'), 's');

const GetImpressionSharePoints = points => _.map(points, point => ({
  primarySegment: formatDate(point.Day, point.Hour),
  value: point.AuctionNumber && (point.ImpressionNumber / point.AuctionNumber),
}));

const GetConversionRatePoints = points => _.map(points, point => ({
  primarySegment: formatDate(point.Day, point.Hour),
  value: point.ClickNumber && (point.ConversionNumber / point.ClickNumber),
}));

const getBudgetChartData = (opportunity) => {
  const competitorData = opportunity.ReferenceCompetitor.CompetitiveInsights[0];
  const youData = opportunity.ReferenceCompetitor.CompetitiveInsights[1];

  const items = [
    {
      name: youData.Key,
      segmentData: GetImpressionSharePoints(youData.Value),
    },
    {
      name: competitorData.Key,
      segmentData: GetImpressionSharePoints(competitorData.Value),
    },
  ];

  return {
    selectedMetric: 'ImpressionShare',
    primarySegmentType: 'Hour',
    items,
  };
};

const normalizeLocation = (
  id,
  location,
  estimatedIncreaseInImpressions = null,
  estimatedIncreaseInClicks = null,
  queriesFiltered = null,
  queriesPassedLocationFiltering = null
) => {
  const type = 'Location';

  return {
    Id: id,
    Criterion: {
      Type: type,
      LocationCriterion: {
        CountryCode: location.CountryCode,
        LocationId: location.LocationId,
        Latitude: location.Latitude,
        Longitude: location.Longitude,
        LocationType: location.LocationType,
        Name: location.ExpandedName,
      },
    },
    EstimatedIncreaseInImpressions: estimatedIncreaseInImpressions,
    EstimatedIncreaseInClicks: estimatedIncreaseInClicks,
    QueriesFiltered: queriesFiltered,
    QueriesPassedLocationFiltering: queriesPassedLocationFiltering,
  };
};

const getNewLocationMapData = (recommendation) => {
  const firstOpportunity = recommendation.Opportunities[0];
  let count = 0;

  const included =
    _.map(firstOpportunity.ExistingLocations, (location) => {
      count += 1;
      return normalizeLocation(count, location);
    });

  const excluded =
    _.map(firstOpportunity.ExcludedLocations, (location) => {
      count += 1;
      return normalizeLocation(count, location);
    });

  const recommended = _.map(recommendation.Opportunities, (opportunity) => {
    count += 1;
    return normalizeLocation(
      count,
      opportunity.Location,
      opportunity.EstimatedIncreaseInImpressions,
      opportunity.EstimatedIncreaseInClicks,
      opportunity.QueriesFiltered,
      opportunity.QueriesPassedLocationFiltering
    );
  });

  return {
    included,
    excluded,
    recommended,
  };
};

const getBidBoostChartData = (recommendation, isDeviceBidBoost = false) => {
  const firstOpportunity = recommendation.Opportunities[0];
  const youData = firstOpportunity.CompetitiveInsights[1];
  const youPoint = {
    name: youData.Key,
    data: [youData.Value[0].ImpressionNumber / youData.Value[0].AuctionNumber],
  };

  const items = _.map(recommendation.Opportunities, (opportunity) => {
    const competitorData = opportunity.CompetitiveInsights[0].Value[0];
    return {
      name: opportunity.CompetitorDomain,
      data: [competitorData.ImpressionNumber / competitorData.AuctionNumber],
    };
  });
  items.unshift(youPoint);

  return {
    selectedMetric: 'ImpressionShare',
    localizeCategory: isDeviceBidBoost,
    category: isDeviceBidBoost ?
      `Details_View_Device_Type_${firstOpportunity.Device}` :
      firstOpportunity.ExpandedName,
    items,
  };
};

const getCompetitiveBidChartData = (recommendation) => {
  const youData = _.find(recommendation.Opportunities[0].CompetitiveInsights, ({ Key }) => Key === 'You');

  const items = _.map(recommendation.Opportunities, (opportunity) => {
    const competitorData = _.find(opportunity.CompetitiveInsights, ({ Key }) => Key !== 'You');
    return {
      name: competitorData.Key,
      segmentData: GetImpressionSharePoints(competitorData.Value),
    };
  });

  // add line for You
  items.unshift({
    name: youData.Key,
    segmentData: GetImpressionSharePoints(youData.Value),
  });

  if (recommendation.Opportunities[0].IsHighConverting) {
    items.push({
      name: youData.Key,
      metric: 'ConversionRate',
      segmentData: GetConversionRatePoints(youData.Value),
    });
  }

  return {
    selectedMetric: 'ImpressionShare',
    secondaryMetric: 'ConversionRate',
    primarySegmentType: 'Day',
    items,
  };
};

const getDetailsVisualData = (type, recommendation) => {
  switch (type) {
    case RECOMMENDATION_TYPES.BUDGET:
      return getBudgetChartData(recommendation.Opportunities[0]);
    case RECOMMENDATION_TYPES.COMPETITIVE_BID:
      return getCompetitiveBidChartData(recommendation);
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST:
      return getBidBoostChartData(recommendation, true);
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST:
      return getBidBoostChartData(recommendation);
    case RECOMMENDATION_TYPES.NEW_LOCATION:
      return getNewLocationMapData(recommendation);
    case RECOMMENDATION_TYPES.SYNDICATION:
    default:
      return null;
  }
};

const getNewKeywordTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        suggestedKeyword: topOpportunity.SuggestedKeyword,
        monthlyQueryVolume: topOpportunity.MonthlyQueryVolume,
        bidSuggested: topOpportunity.SuggestedBid,
        impressionsIncrease: topOpportunity.EstimatedIncreaseInImpressions,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getNewKeywordOpportunityTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        recommendedKeyword: topOpportunity.SuggestedKeyword,
        matchType: topOpportunity.MatchType,
        recommendedSource: topOpportunity.SourcesForBingAdsWebUi[0],
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getDynamicSearchAdsTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = _.first(recommendation.Opportunities);
    if (topOpportunity) {
      row = { searchExamples: topOpportunity.SearchExamples };
    }

    return row;
  });

  return _.compact(rows);
};

const getSyndicationTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        campaignName: topOpportunity.Target.CampaignName,
        adGroupName: topOpportunity.Target.AdGroupName,
        adoptionPercentage: topOpportunity.CompetitorAdoptionPercentage,
        impressionsIncrease: topOpportunity.EstimatedIncreaseInImpressions,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getExtensionTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        campaignName: topOpportunity.Target.CampaignName,
        ctrLift: topOpportunity.CtrLift,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getBudgetOpportunityTable = (recommendations, primaryEstimate, isShared = false) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      if (isShared) {
        row = { entityName: topOpportunity.Shared.BudgetName };
      } else {
        row = { entityName: topOpportunity.Target.CampaignName };
      }
      if (primaryEstimate === ESTIMATE_TYPES.CONVERSIONS) {
        row.convIncrease = topOpportunity.EstimatedIncreaseInConversionsInt;
      } else {
        row.clicksIncrease = topOpportunity.EstimatedIncreaseInClicks;
      }
    }

    return row;
  });

  return _.compact(rows);
};

const getRepairTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        adGroupName: topOpportunity.Target.AdGroupName,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getRemoveConflictingNegativeKeywordTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        negativeKeyword: topOpportunity.NegativeKeyword,
        blockedKeyword: _.first(topOpportunity.BlockedKeywordList).Keyword,
        matchType: topOpportunity.NegativeKeywordMatchTypeId,
        blockedKeywordMatchType: _.first(topOpportunity.BlockedKeywordList).MatchTypeId,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getResponsiveSearchAdsTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        adGroupName: topOpportunity.Target.AdGroupName,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getReallocateBudgetTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    const fromCampaign = _.find(
      topOpportunity.SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Surplus
    );
    const toCampaign = _.find(
      topOpportunity.SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Deficit
    );
    if (topOpportunity) {
      row = {
        fromCampaign: fromCampaign.CampaignName,
        toCampaign: toCampaign.CampaignName,
        suggestBudget: toCampaign.BudgetDeficit,
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getFixAdDestinationTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        UrlOrLandingPage: topOpportunity.UrlOrLandingPage,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getBroadMatchKeywordTable = (samples) => {
  const rows = _.map(samples, (sample) => {
    const row = {
      recommendedKeyword: sample.SampleContent,
    };

    return row;
  });

  return _.compact(rows);
};

const getFixAdTextTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const opportunity = recommendation.Opportunities[0];

    if (opportunity) {
      row = {
        policyCode: opportunity.FlagId,
        numberRejectedAds:
          opportunity.NumberRejectedDisapprovedAds +
          opportunity.NumberRejectedLimitedApprovedAds,
        numberRejectedKeywords:
          opportunity.NumberRejectedDisapprovedKeywords +
          opportunity.NumberRejectedLimitedApprovedKeywords,
      };
    }
    return row;
  });

  return _.compact(rows);
};

const getTrendingQueryTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        recommendedKeyword: topOpportunity.SuggestedKeyword,
        matchType: topOpportunity.MatchType,
        searchVolumeIncrease: topOpportunity.WoWInDecimal || topOpportunity.WoW,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getMultiMediaAdsTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        adGroupName: topOpportunity.Target.AdGroupName,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getImageExtensionTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        campaignName: topOpportunity.Target.CampaignName,
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getRepairMissingKeywordParamsTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        keyword: topOpportunity.Target.Keyword,
        impressionsIncrease: topOpportunity.EstimatedIncreaseInImpressions,
        impressionsCurrent: topOpportunity.CurrentImpressions,
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getFixNoImpressionBidTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        keyword: topOpportunity.Target.Keyword,
        suggestedBid: topOpportunity.SuggestedBid,
        impressionsIncrease: topOpportunity.EstimatedIncreaseInImpressions,
        source: topOpportunity.Source,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getRepairUntargetedOfferTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        campaignName: getFieldValueFromGridData(topOpportunity.GridData, 'CampaignName'),
        impressionsIncrease: topOpportunity.EstimatedIncreaseInImpressions,
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
        targetedProductsIncrease: topOpportunity.TotalUntargetedOfferCnt,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getImproveMultiMediaAdsTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const opportunity = recommendation.Opportunities[0];
    if (opportunity) {
      row = {
        Images: opportunity.Images,
        Headlines: opportunity.Headlines,
        LongHeadlines: opportunity.LongHeadlines,
        Descriptions: opportunity.Descriptions,
        OpportunityId: opportunity.OpportunityId,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getSSC2PMaxMigrationTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
        campaignName: topOpportunity.Target.CampaignName,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getDSA2PMaxMigrationTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        convIncrease: topOpportunity.EstimatedIncreaseInConversionsInt,
      };
    }

    return row;
  });

  return _.compact(rows);
};

const getSyndicationGapTable = (recommendations) => {
  const rows = _.map(recommendations, (recommendation) => {
    let row;
    const topOpportunity = recommendation.Opportunities[0];
    if (topOpportunity) {
      row = {
        clicksIncrease: topOpportunity.EstimatedIncreaseInClicks,
        campaignName: topOpportunity.Target.CampaignName,
        convIncrease: topOpportunity.EstimatedIncreaseInConversionsInt,
      };
    }

    return row;
  });

  return _.compact(rows);
};
// #endregion chart/map/table

// #region sample
const sortOpportunitiesInRecommendation = (recommendation, type) => {
  let sortedOpportunities = null;
  switch (type) {
    case RECOMMENDATION_TYPES.COMPETITIVE_BID:
      sortedOpportunities = _.sortBy(recommendation.Opportunities, 'SuggestedBid');
      break;
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST:
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST:
      sortedOpportunities = _.sortBy(recommendation.Opportunities, 'SuggestedBidBoost');
      break;
    case RECOMMENDATION_TYPES.NEW_LOCATION:
      sortedOpportunities = _.sortBy(recommendation.Opportunities, 'EstimatedIncreaseInClicks');
      break;
    // Budget, new keyword, syndication are 1 to 1
    // no need to sort other opportunities
    default:
      break;
  }

  return _.extend(
    {},
    recommendation,
    {
      Opportunities: sortedOpportunities ?
        sortedOpportunities.reverse() : recommendation.Opportunities,
    }
  );
};

/**
 * If DefaultOpportunityId is defined, return corresponding opportunity
 * If not, use top opportunity
 * @param {Object} sortedRecommendation - sorted recommendation
 * @return {Object} recommended opportunity
 */
const getRecommendedOpportunity = (sortedRecommendation) => {
  let opportunity = null;
  if (sortedRecommendation.DefaultOpportunityId) {
    opportunity = _.findWhere(
      sortedRecommendation.Opportunities,
      { OpportunityId: sortedRecommendation.DefaultOpportunityId }
    );
  } else {
    [opportunity] = sortedRecommendation.Opportunities;
  }

  return opportunity;
};

const getActionData = (
  type,
  topRecommendation,
  recommendedOpportunity
) => {
  switch (type) {
    case RECOMMENDATION_TYPES.BUDGET: {
      return [
        {
          budgetCurrent: recommendedOpportunity.CurrentBudget,
          budgetIncrease: recommendedOpportunity.EstimatedIncreaseInBudget,
          imprShareIncrease: recommendedOpportunity.EstimatedIncreaseInImprShare,
        },
      ];
    }
    case RECOMMENDATION_TYPES.COMPETITIVE_BID: {
      return [
        {
          keyword: recommendedOpportunity.Target.Keyword,
          bidCurrent: recommendedOpportunity.CurrentBid,
          bidSuggested: recommendedOpportunity.SuggestedBid,
          imprShareIncrease: recommendedOpportunity.TargetSelfImprShare -
            recommendedOpportunity.CurSelfImprShare,
        },
      ];
    }
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST: {
      return [
        {
          device: recommendedOpportunity.Device,
          currentBidAdjustmentPercent: recommendedOpportunity.CurrentBidBoost,
          suggestedBidAdjustmentPercent: recommendedOpportunity.SuggestedBidBoost,
          imprShareIncrease: recommendedOpportunity.EstimatedIncreaseInImprShare,
        },
      ];
    }
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST: {
      return [
        {
          location: recommendedOpportunity.ExpandedName || recommendedOpportunity.GeoLocationId,
          currentBidAdjustmentPercent: recommendedOpportunity.CurrentBidBoost,
          suggestedBidAdjustmentPercent: recommendedOpportunity.SuggestedBidBoost,
          imprShareIncrease: recommendedOpportunity.EstimatedIncreaseInImprShare,
        },
      ];
    }
    case RECOMMENDATION_TYPES.NEW_LOCATION: {
      return _.map(topRecommendation.Opportunities, opportunity => ({
        location: opportunity.Location.ExpandedName,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
      }));
    }
    case RECOMMENDATION_TYPES.NEW_KEYWORD:
    default:
      return null;
  }
};
// #endregion sample

// #region individual recommendation
const getOpportunity = (type, opportunity, defaultOpId) => {
  const opportunityId = opportunity.OpportunityId;
  const isDefault = opportunityId === defaultOpId;

  switch (type) {
    case RECOMMENDATION_TYPES.BUDGET:
      return {
        opportunityId,
        budgetCurrent: opportunity.CurrentBudget,
        budgetSuggested: opportunity.CurrentBudget + opportunity.EstimatedIncreaseInBudget,
      };
    case RECOMMENDATION_TYPES.COMPETITIVE_BID: {
      return {
        opportunityId,
        isDefault,
        suggestedBid: opportunity.SuggestedBid,
        imprShareIncrease: opportunity.TargetSelfImprShare -
          opportunity.CurSelfImprShare,
        totalImprShare: opportunity.TargetSelfImprShare,
        weeklyCost: opportunity.EstimatedIncreaseInCost + opportunity.CurrentCost,
        competitorDomain: opportunity.CompetitorDomain,
        competitorImprShare: opportunity.CompetitorImprShare,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
        convIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST:
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST: {
      const competitorData = opportunity.CompetitiveInsights[0].Value[0];
      return {
        opportunityId,
        isDefault,
        suggestedBidAdjustmentPercent: opportunity.SuggestedBidBoost,
        imprShareIncrease: opportunity.EstimatedIncreaseInImprShare,
        totalImprShare: opportunity.EstimatedIncreaseInImprShare + opportunity.CurSelfImprShare,
        weeklyCost: opportunity.EstimatedIncreaseInCost + opportunity.CurrentCost,
        competitorDomain: opportunity.CompetitorDomain,
        competitorImprShare: competitorData.ImpressionNumber / competitorData.AuctionNumber,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
        convIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    // deprecated in Oct 2023
    case RECOMMENDATION_TYPES.NEW_KEYWORD: {
      return {
        opportunityId,
        suggestedBid: opportunity.SuggestedBid,
        suggestedKeyword: opportunity.SuggestedKeyword,
        matchType: opportunity.MatchType,
        monthlyQueryVolume: opportunity.MonthlyQueryVolume,
      };
    }
    case RECOMMENDATION_TYPES.NEW_LOCATION: {
      return {
        opportunityId,
        location: opportunity.Location.ExpandedName,
        searchQueryVolume: opportunity.QueriesFiltered,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        costIncrease: opportunity.EstimatedIncreaseInCost,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.SYNDICATION:
      return {
        opportunityId,
        adoptionPercent: opportunity.CompetitorAdoptionPercentage,
      };
    case RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY: {
      return {
        opportunityId,
        recommendedKeyword: opportunity.SuggestedKeyword,
        matchType: opportunity.MatchType,
        recommendedSource: opportunity.SourcesForBingAdsWebUi[0],
      };
    }
    case RECOMMENDATION_TYPES.TRENDING_QUERY: {
      return {
        opportunityId,
        recommendedKeyword: opportunity.SuggestedKeyword,
        matchType: opportunity.MatchType,
        monthlySearchVolume: opportunity.MonthlySearchVolume,
        weekoverWeek: opportunity.WoWInDecimal || opportunity.WoW,
      };
    }
    case RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS: {
      return {
        opportunityId,
        weeklySearchesIncrease: opportunity.EstimatedIncreaseInSearches,
        searchExamples: opportunity.SearchExamples,
      };
    }
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT:
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED:
    case RECOMMENDATION_TYPES.FACEBOOK_IMPORT:
    case RECOMMENDATION_TYPES.PMAX_IMPORT: {
      return {
        opportunityId,
      };
    }
    case RECOMMENDATION_TYPES.SITE_LINK:
    case RECOMMENDATION_TYPES.CALLOUT: {
      return {
        opportunityId,
        ctrLift: opportunity.CtrLift,
        campaignName: opportunity.Target.CampaignName,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        costIncrease: opportunity.EstimatedIncreaseInCost,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY:
    case RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY: {
      return {
        opportunityId,
        convIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    case RECOMMENDATION_TYPES.REPAIR_ADS: {
      return {
        opportunityId,
        adGroupName: opportunity.Target.AdGroupName,
        campaignName: opportunity.Target.CampaignName,
      };
    }
    case RECOMMENDATION_TYPES.REPAIR_KEYWORD: {
      return {
        opportunityId,
        adGroupName: opportunity.Target.AdGroupName,
        campaignName: opportunity.Target.CampaignName,
      };
    }
    case RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD: {
      return {
        opportunityId,
        recommendedKeyword: opportunity.ReferenceKeyword,
      };
    }
    case RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD: {
      return {
        opportunityId,
        negativeKeyword: opportunity.NegativeKeyword,
        blockedKeyword: _.first(opportunity.BlockedKeywordList).Keyword,
      };
    }
    case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS: {
      return {
        opportunityId,
        adGroupName: opportunity.Target.AdGroupName,
      };
    }
    case RECOMMENDATION_TYPES.REALLOCATE_BUDGET: {
      const fromCampaign = _.find(
        opportunity.SuggestedCampaignBudgets,
        campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Surplus
      );
      const toCampaign = _.find(
        opportunity.SuggestedCampaignBudgets,
        campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Deficit
      );
      return {
        opportunityId,
        fromCampaign: fromCampaign.CampaignName,
        toCampaign: toCampaign.CampaignName,
        suggestBudget: toCampaign.BudgetDeficit,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.FIX_AD_DESTINATION: {
      return {
        opportunityId,
        rejectedAd: opportunity.RejectedAd,
      };
    }
    case RECOMMENDATION_TYPES.FIX_AD_TEXT: {
      return {
        opportunityId,
        rejectionCode: opportunity.FlagId,
        rejectedAds: opportunity.RejectedAds,
        rejectedKeywords: opportunity.RejectedKeywords,
      };
    }
    case RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY: {
      return {
        opportunityId,
        inactiveTagCount: opportunity.NumInactiveUetTags,
        affectedGoal: opportunity.NumAffectedConversionGoals,
      };
    }
    case RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY: {
      return {
        opportunityId,
        numImpressions: opportunity.NumImpressions,
        numClicks: opportunity.NumClicks,
      };
    }
    case RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS: {
      return {
        opportunityId,
        missingConvIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    case RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL: {
      return {
        opportunityId,
        missingConvIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    case RECOMMENDATION_TYPES.MULTIMEDIA_ADS: {
      return {
        opportunityId,
        adGroupName: opportunity.Target.AdGroupName,
      };
    }
    case RECOMMENDATION_TYPES.IMAGE_EXTENSION: {
      return {
        opportunityId,
        campaignName: opportunity.Target.CampaignName,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS: {
      return {
        opportunityId,
        keyword: opportunity.Target.Keyword,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        impressionsCurrent: opportunity.CurrentImpressions,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID: {
      return {
        opportunityId,
        campaignName: opportunity.Target.CampaignName,
      };
    }
    case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS: {
      return {
        opportunityId,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER: {
      return {
        opportunityId,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        impressionsCurrent: opportunity.CurrentImpressions,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
        targetedProductsIncrease: opportunity.TotalUntargetedOfferCnt,
      };
    }
    case RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS: {
      return {
        opportunityId,
        impressionsIncrease: opportunity.EstimatedIncreaseInImpressions,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
      };
    }
    case RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION: {
      return {
        opportunityId,
        campaignName: opportunity.Target.CampaignName,
      };
    }
    case RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION: {
      return {
        opportunityId,
        convIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    case RECOMMENDATION_TYPES.SYNDICATION_GAP: {
      return {
        opportunityId,
        clicksIncrease: opportunity.EstimatedIncreaseInClicks,
        convIncrease: opportunity.EstimatedIncreaseInConversionsInt,
      };
    }
    default:
      throw new Error(`Not Implemented: ${type}`);
  }
};


const getRecommendation = (type, recommendedOpportunity) => {
  const target = recommendedOpportunity.Target;

  let delta;
  let segment;
  let competitor;
  let seasonalEvent;
  if (type === RECOMMENDATION_TYPES.DEVICE_BID_BOOST ||
    type === RECOMMENDATION_TYPES.LOCATION_BID_BOOST) {
    const competitorData = recommendedOpportunity.CompetitiveInsights[0].Value[0];
    const youData = recommendedOpportunity.CompetitiveInsights[1].Value[0];

    competitor = recommendedOpportunity.CompetitiveInsights[0].Key;
    delta = (competitorData.ImpressionNumber / competitorData.AuctionNumber) -
      (youData.ImpressionNumber / youData.AuctionNumber);
    segment = recommendedOpportunity.ExpandedName || recommendedOpportunity.Device;
  }

  if (_.contains(BUDGET_OPPORTUNITY_TYPES, type)) {
    seasonalEvent = _.size(recommendedOpportunity.SeasonalEvents) > 0 &&
      recommendedOpportunity.SeasonalEvents[0].Name;
  }

  const isHighConverting = !!recommendedOpportunity.IsHighConverting;

  return _.extend(
    {},
    {
      target,
      competitor,
      delta,
      segment,
      seasonalEvent,
      isHighConverting,
    }
  );
};
// #endregion individual recommendation

// #region visualData
const getSampleVisualData = ({
  type,
  topRecommendation,
  recommendations,
  primaryEstimate = null,
  rawSamples = null,
}) => {
  switch (type) {
    case RECOMMENDATION_TYPES.BUDGET:
    case RECOMMENDATION_TYPES.COMPETITIVE_BID:
    case RECOMMENDATION_TYPES.DEVICE_BID_BOOST:
    case RECOMMENDATION_TYPES.LOCATION_BID_BOOST:
    case RECOMMENDATION_TYPES.NEW_LOCATION:
      return getDetailsVisualData(type, topRecommendation);
    // deprecated in Oct 2023
    case RECOMMENDATION_TYPES.NEW_KEYWORD:
      return getNewKeywordTable(recommendations);
    case RECOMMENDATION_TYPES.SYNDICATION:
      return getSyndicationTable(recommendations);
    case RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY:
      return getNewKeywordOpportunityTable(recommendations);
    case RECOMMENDATION_TYPES.TRENDING_QUERY:
      return getTrendingQueryTable(recommendations);
    case RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS:
      return getDynamicSearchAdsTable(recommendations);
    case RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY:
      return getBudgetOpportunityTable(
        recommendations,
        primaryEstimate
      );
    case RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY:
      return getBudgetOpportunityTable(
        recommendations,
        primaryEstimate,
        true
      );
    case RECOMMENDATION_TYPES.SITE_LINK:
    case RECOMMENDATION_TYPES.CALLOUT:
      return getExtensionTable(recommendations);
    case RECOMMENDATION_TYPES.REPAIR_ADS:
    case RECOMMENDATION_TYPES.REPAIR_KEYWORD:
      return getRepairTable(recommendations);
    case RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD:
      return getBroadMatchKeywordTable(rawSamples);
    case RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD:
      return getRemoveConflictingNegativeKeywordTable(recommendations);
    case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS:
      return getResponsiveSearchAdsTable(recommendations);
    case RECOMMENDATION_TYPES.REALLOCATE_BUDGET:
      return getReallocateBudgetTable(recommendations);
    case RECOMMENDATION_TYPES.FIX_AD_DESTINATION:
      return getFixAdDestinationTable(recommendations);
    case RECOMMENDATION_TYPES.FIX_AD_TEXT:
      return getFixAdTextTable(recommendations);
    case RECOMMENDATION_TYPES.MULTIMEDIA_ADS:
      return getMultiMediaAdsTable(recommendations);
    case RECOMMENDATION_TYPES.IMAGE_EXTENSION:
      return getImageExtensionTable(recommendations);
    case RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS:
      return getRepairMissingKeywordParamsTable(recommendations);
    case RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID:
      return getFixNoImpressionBidTable(recommendations);
    case RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER:
      return getRepairUntargetedOfferTable(recommendations);
    case RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS:
      return getImproveMultiMediaAdsTable(recommendations);
    case RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION:
      return getSSC2PMaxMigrationTable(recommendations);
    case RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION:
      return getDSA2PMaxMigrationTable(recommendations);
    case RECOMMENDATION_TYPES.SYNDICATION_GAP:
      return getSyndicationGapTable(recommendations);
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT:
    case RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED:
    case RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY:
    case RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY:
    case RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS:
    case RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL:
    case RECOMMENDATION_TYPES.FACEBOOK_IMPORT:
    case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS:
    case RECOMMENDATION_TYPES.PMAX_IMPORT:
      return null;
    default:
      throw new Error(`Not Implemented: ${type}`);
  }
};
// #endregion visualData

const getGridData = (opportunities) => {
  let gridData;
  const topOpportunity = opportunities[0];
  if (topOpportunity) {
    gridData = Object.assign(topOpportunity, gridData);
  }
  return gridData;
};

const getRecommendationWithDetails = (type, recommendation) => {
  const sortedRecommendation = sortOpportunitiesInRecommendation(recommendation, type);
  const recommendedOpportunity = getRecommendedOpportunity(sortedRecommendation);
  const data = getRecommendation(type, recommendedOpportunity);
  const visualData = getDetailsVisualData(type, sortedRecommendation);

  let estimates;
  if (type === RECOMMENDATION_TYPES.BUDGET ||
    type === RECOMMENDATION_TYPES.NEW_KEYWORD || // deprecated in Oct 2023
    type === RECOMMENDATION_TYPES.SYNDICATION) {
    estimates = getEstimates(type, recommendedOpportunity);
  }

  const currentBidAdjustmentPercent = recommendedOpportunity.CurrentBidBoost;
  const imprShareCurrent = recommendedOpportunity.CurSelfImprShare;
  const costCurrent = recommendedOpportunity.CurrentCost;
  const bidCurrent = recommendedOpportunity.CurrentBid;
  const targetGroupId = recommendedOpportunity.TargetGroupId;

  const opportunities = _.map(
    sortedRecommendation.Opportunities,
    rawOpportunity => getOpportunity(
      type,
      rawOpportunity,
      sortedRecommendation.DefaultOpportunityId
    )
  );

  const gridData = getGridData(opportunities);

  return _.extend(
    data,
    {
      visualData,
      opportunities,
      estimates,
      currentBidAdjustmentPercent,
      imprShareCurrent,
      costCurrent,
      bidCurrent,
      targetGroupId,
      gridData,
    }
  );
};

const getRecommendationSample = ({
  type,
  rawSummary: {
    Samples,
    Recommendations,
  },
  estimates,
}) => {
  const topRecommendation = sortOpportunitiesInRecommendation(Recommendations[0], type);
  const recommendedOpportunity = getRecommendedOpportunity(topRecommendation);

  const data = getRecommendation(type, recommendedOpportunity);

  const actions = getActionData(
    type,
    topRecommendation,
    recommendedOpportunity
  );

  const visualData = getSampleVisualData({
    type,
    topRecommendation,
    recommendations: Recommendations,
    primaryEstimate: estimates && estimates.primaryEstimate,
    rawSamples: Samples,
  });

  return _.extend(
    data,
    {
      actions,
      visualData,
    }
  );
};

/**
 * Normalize AdInsight Recommendation MT response
 * 1. extract useful fields
 * 2. calculate, transform, sort data
 * @param {Object} rawData - rawData from MT.
 * @param {boolean} withDetails - process recommendations data or not
 * @returns {Object} An object of all processed data, key is the type
 */
export const normalize = (rawData, withDetails = false) => {
  const hasDismissedSummaries =
    rawData.DismissTabSummaries && rawData.DismissTabSummaries.length > 0;
  const dismissedSummaries = hasDismissedSummaries ? _.map(rawData.DismissTabSummaries, (e) => {
    e.Category = 'Dismissed';
    return e;
  }) : [];
  const filteredSummaries = _.filter(rawData.value, e => (
    e.RecommendationsCount !== 0 && !TOP_POSITION_RECOMMENDATION_TYPES.includes(e.OpportunityType)));
  const topPositionSummaries = _.filter(rawData.value, e => TOP_POSITION_RECOMMENDATION_TYPES.includes(e.OpportunityType));

  const summaries = _.map([topPositionSummaries, filteredSummaries, dismissedSummaries], rawSummaries =>
    _.map(rawSummaries, (rawSummary) => {
      // static properties
      const category = rawSummary.Category;
      const type = rawSummary.OpportunityType;
      const level = rawSummary.AggregateLevel;
      const recommendationsCount = rawSummary.RecommendationsCount;
      const opportunityCount = rawSummary.OpportunitiesCount;
      const version = rawSummary.Version;
      const coupon = rawSummary.Coupon;
      const accounts = rawSummary.Accounts;
      const optimizationScore = rawSummary.ScoreUpLift;
      const isNrt = rawSummary.IsNrt;
      const statusId = rawSummary.StatusId;
      const hasAIAssetRecommendation = rawSummary.HasAIAssetRecommendationCount ?
        rawSummary.HasAIAssetRecommendationCount > 0 : undefined;
      const isAutoApplyOptIn = rawSummary.IsAutoApplyOptIn
        && category !== RECOMMENDATION_CATEGORIES.DISMISSED;
      const thirdPartyInfos = rawSummary.ThirdPartyInfos ? rawSummary.ThirdPartyInfos : undefined;

      // calculated properties
      const estimates = getEstimates(type, rawSummary);
      const sample = getRecommendationSample({
        type,
        rawSummary,
        estimates,
      });
      const recommendations = withDetails && _.map(
        rawSummary.Recommendations,
        rawRecommendation => getRecommendationWithDetails(type, rawRecommendation)
      );

      const isHighConverting = type === RECOMMENDATION_TYPES.COMPETITIVE_BID && _.every(
        rawSummary.Recommendations,
        recommendation => recommendation.Opportunities[0].IsHighConverting
      );

      const isSeasonal = _.contains(BUDGET_OPPORTUNITY_TYPES, type) &&
        ((rawSummary.Recommendations[0].Opportunities[0].TrackId & SEASONAL_TRACKID) != 0) && // eslint-disable-line
        !_.isEmpty(rawSummary.Recommendations[0].Opportunities[0].SeasonalEvents);

      const isFeedbackPersonalized = rawSummary.IsFeedbackPersonalized;
      const seasonalEntity = {
        seasonalEvent: rawSummary.Samples,
        sources: rawSummary.Sources,
      };

      let optInStatus;
      let applyDate;
      if (type === RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS) {
        optInStatus = rawSummary.IsOptIn;
        applyDate = rawSummary.NearestApplyDate || 0;
      } else if (type === RECOMMENDATION_TYPES.MULTIMEDIA_ADS ||
        _.contains(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES, type)) {
        optInStatus = rawSummary.AarOptInRecommendationCount > 0;
        applyDate = rawSummary.AarNearestApplyDate;
      }

      const summary = _.extend(
        {
          category,
          type,
          level,
          recommendationsCount,
          opportunityCount,
          estimates,
          sample,
          isHighConverting,
          isSeasonal,
          version,
          optInStatus: optInStatus && category !== RECOMMENDATION_CATEGORIES.DISMISSED,
          applyDate,
          accounts,
          optimizationScore,
          isNrt,
          statusId,
          hasAIAssetRecommendation,
          isFeedbackPersonalized,
          isAutoApplyOptIn,
          seasonalEntity,
          thirdPartyInfos,
        },
        recommendations && { recommendations },
        coupon && { coupon }
      );

      return [
        type,
        summary,
      ];
    }));

  return _.defaults({}, _.object(summaries[0]), _.object(summaries[1]), hasDismissedSummaries ?
    { Dismissed: _.object(summaries[2]) } : {});
};
